module.exports = __webpack_public_path__ + "static/media/ico-edit.794b0cce.svg";